const initialState = {
  isOpen: false,
};

const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_SCHEDULE_MODAL":
      return { ...state, isOpen: true };
    case "CLOSE_SCHEDULE_MODAL":
      return { ...state, isOpen: false };
    default:
      return state;
  }
};
export default scheduleReducer;
